(function ($, window, document) {
	var $win = $(window);
	var $doc = $(document);
	var myResponse;
	var markers = [];
	var lastScrollTop = 0;
	const breakpointMobile = window.matchMedia(
		"(max-width: 767px), screen and (max-width: 812px) and (orientation: landscape)"
	);

	const $header = $(".header");
	const $registerPopup = $(".section-register");

	var mapStyles = [
		{
			featureType: "water",
			elementType: "geometry",
			stylers: [
				{
					color: "#e9e9e9",
				},
				{
					lightness: 17,
				},
			],
		},
		{
			featureType: "landscape",
			elementType: "geometry",
			stylers: [
				{
					color: "#f5f5f5",
				},
				{
					lightness: 20,
				},
			],
		},
		{
			featureType: "road.highway",
			elementType: "geometry.fill",
			stylers: [
				{
					color: "#ffffff",
				},
				{
					lightness: 17,
				},
			],
		},
		{
			featureType: "road.highway",
			elementType: "geometry.stroke",
			stylers: [
				{
					color: "#ffffff",
				},
				{
					lightness: 29,
				},
				{
					weight: 0.2,
				},
			],
		},
		{
			featureType: "road.arterial",
			elementType: "geometry",
			stylers: [
				{
					color: "#ffffff",
				},
				{
					lightness: 18,
				},
			],
		},
		{
			featureType: "road.local",
			elementType: "geometry",
			stylers: [
				{
					color: "#ffffff",
				},
				{
					lightness: 16,
				},
			],
		},
		{
			featureType: "poi",
			elementType: "geometry",
			stylers: [
				{
					color: "#f5f5f5",
				},
				{
					lightness: 21,
				},
			],
		},
		{
			featureType: "poi.park",
			elementType: "geometry",
			stylers: [
				{
					color: "#dedede",
				},
				{
					lightness: 21,
				},
			],
		},
		{
			elementType: "labels.text.stroke",
			stylers: [
				{
					visibility: "on",
				},
				{
					color: "#ffffff",
				},
				{
					lightness: 16,
				},
			],
		},
		{
			elementType: "labels.text.fill",
			stylers: [
				{
					saturation: 36,
				},
				{
					color: "#333333",
				},
				{
					lightness: 40,
				},
			],
		},
		{
			elementType: "labels.icon",
			stylers: [
				{
					visibility: "off",
				},
			],
		},
		{
			featureType: "transit",
			elementType: "geometry",
			stylers: [
				{
					color: "#f2f2f2",
				},
				{
					lightness: 19,
				},
			],
		},
		{
			featureType: "administrative",
			elementType: "geometry.fill",
			stylers: [
				{
					color: "#fefefe",
				},
				{
					lightness: 20,
				},
			],
		},
		{
			featureType: "administrative",
			elementType: "geometry.stroke",
			stylers: [
				{
					color: "#fefefe",
				},
				{
					lightness: 17,
				},
				{
					weight: 1.2,
				},
			],
		},
	];

	$.fn.isInViewport = function () {
		var elementTop = $(this).offset().top;
		var elementBottom = elementTop + $(this).outerHeight();

		var viewportTop = $(window).scrollTop() - $(window).height() * 0.5;
		var viewportBottom = viewportTop + $(window).height();

		return elementBottom > viewportTop && elementTop < viewportBottom;
	};

	function window_width() {
		var myWidth = 0;
		if (typeof window.innerWidth == "number") myWidth = window.innerWidth;
		else if (
			document.documentElement &&
			document.documentElement.clientWidth
		)
			myWidth = document.documentElement.clientWidth;
		else if (document.body && document.body.clientWidth)
			myWidth = document.body.clientWidth;
		return myWidth;
	}

	function window_height() {
		var myHeight = 0;
		if (typeof window.innerHeight == "number")
			myHeight = window.innerHeight;
		else if (
			document.documentElement &&
			document.documentElement.clientHeight
		)
			myHeight = document.documentElement.clientHeight;
		else if (document.body && document.body.clientHeight)
			myHeight = document.body.clientHeight;
		return myHeight;
	}

	var tag = document.createElement("script");
	tag.src = "https://www.youtube.com/iframe_api";
	var firstScriptTag = document.getElementsByTagName("script")[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

	var player;
	var videoID = document.querySelectorAll(".video-youtube");

	function onYouTubeIframeAPIReady() {
		if ($(videoID).length == 0) {
			return;
		}
		$(videoID).each(function (index, el) {
			var videoID = $(el).attr("data-videoID");
			player = new YT.Player(el, {
				width: "100%",
				videoId: videoID,
				playerVars: {
					autoplay: 1,
					playsinline: 1,
					playlist: videoID,
					loop: 1,
					controls: 0,
					modestbranding: 1,
					frameborder: 0,
					mute: 1,
				},
				events: {
					onReady: onPlayerReady,
				},
			});
		});
	}

	function onPlayerReady(event) {
		event.target.mute();
		event.target.playVideo();
	}

	var playerBtn;
	var videoWithBtn = document.querySelectorAll(".video-youtube-btn");

	function onYouTubeIframeAPIReadyBtn() {
		if ($(videoWithBtn).length == 0) {
			return;
		}
		$(videoWithBtn).each(function (index, el) {
			var videoID = $(el).attr("data-videoID");
			var playPauseBtn = $(el)
				.parents(".media")
				.find(".js-video-youtube");
			var videoHolder = $(el).parents(".media").find(".video-alt");
			var btnHolder = $(el).parents(".media").find(".media__btn");

			playerBtn = new YT.Player(el, {
				width: "100%",
				videoId: videoID,
				playerVars: { controls: 1 },
			});

			$(playPauseBtn).on("click", function (e) {
				e.preventDefault();
				if (!$(videoHolder).hasClass("play")) {
					playerBtn.playVideo();
					$(videoHolder).addClass("play");
					$(btnHolder).addClass("play");
				} else {
					playerBtn.pauseVideo();
					$(videoHolder).removeClass("play");
					$(btnHolder).removeClass("play");
				}
			});
		});
	}

	function initVideo() {
		if ($(".js-video").length == 0) {
			return;
		}

		$doc.on("click", ".js-video", function (e) {
			e.preventDefault();
			var videoHolder = $(this).parents(".media").find(".video-alt");
			if (!$(videoHolder).hasClass("play")) {
				$(videoHolder).addClass("play");
				$(videoHolder).find(".video__content")[0].play();
				$(this).parents(".media__btn").addClass("play");
			} else {
				$(videoHolder).removeClass("play");
				$(videoHolder).find(".video__content")[0].pause();
				$(this).parents(".media__btn").removeClass("play");
			}
		});
	}

	function initSlider() {
		$(".js-slider").on("init", function (event, slick) {
			var total = $(this).find(".slick-slide").length;
			var current =
				$(this).find(".slick-current").data("slick-index") + 1;
			var $slider = $(slick.$slider[0]).parents(".slider");
			$($slider).find(".total").html(total);
			$($slider).find(".current-index").html(current);
			if (total <= 1) {
				$($slider).find(".slider__counter").css("opacity", "0");
			}
		});

		$(".js-slider").slick({
			arrows: false,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 2000,
			fade: true,
			speed: 200,
			cssEase: "linear",
		});

		$(".js-slider").on(
			"afterChange",
			function (event, slick, currentSlide, nextSlide) {
				var $slider = $(slick.$slider[0]).parents(".slider");
				$($slider)
					.find(".current-index")
					.html(currentSlide + 1);
				$($($slider).find(".js-captions li")[currentSlide])
					.addClass("current")
					.siblings()
					.removeClass("current");
			}
		);
	}

	function initSliderAlt() {
		$(".js-slider-alt").on("init", function (event, slick) {
			var total = $(this).find(".slick-slide").length;
			var current =
				$(this).find(".slick-current").data("slick-index") + 1;
			var $slider = $(slick.$slider[0]).parents(".slider");
			$($slider).find(".total").html(total);
			$($slider).find(".current-index").html(current);
			if (total <= 1) {
				$($slider).find(".slider__counter").css("opacity", "0");
			}
		});

		$(".js-slider-alt").slick({
			arrows: true,
			infinite: true,
			fade: true,
			speed: 200,
			swipeToSlide: true,
			cssEase: "linear",
		});

		$doc.on("click", ".js-slider-alt", function (e) {
			const sliderHorizontalSpace =
				$(this).offset().left + $(this).outerWidth();
			const clickXpos = e.pageX;

			if (breakpointMobile.matches) {
				if (clickXpos <= sliderHorizontalSpace / 2) {
					$(this).slick("slickPrev");
				} else {
					$(this).slick("slickNext");
				}
			}
		});

		$(".js-slider-alt").on(
			"afterChange",
			function (event, slick, currentSlide, nextSlide) {
				var $slider = $(slick.$slider[0]).parents(".slider");
				$($slider)
					.find(".current-index")
					.html(currentSlide + 1);
				$($($slider).find(".js-captions li")[currentSlide])
					.addClass("current")
					.siblings()
					.removeClass("current");
			}
		);
	}

	function initTextImageSliders() {
		const $textImageSliderContainers = $(".js-text-image-slider");

		$textImageSliderContainers.each(function () {
			const $sliderContainer = $(this);
			const $slider = $sliderContainer.find(".js-text-image-slider-slides");
			const $sliderIndex = $sliderContainer.find(".js-text-image-slider-index");

			function createTextImageSlider() {
				$slider.slick({
					arrows: true,
					autoplay: true,
					draggable: false,
					fade: true,
					infinite: true,
					touchMove: false,
					pauseOnHover: false,
				});

				$slider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
					$sliderIndex.text(`${nextSlide + 1}`);
				});
			}

			if ($win.outerWidth() >= 768) {
				createTextImageSlider();
			}

			$win.on("resize", function () {
				if ($win.outerWidth() >= 768 && !$slider.hasClass("slick-initialized")) {
					createTextImageSlider();
				} else if ($win.outerWidth() < 768 && $slider.hasClass("slick-initialized")) {
					$slider.slick("destroy");
				}
			});
		});
	}

	function initRenderComparisonSlider(section) {
		const slider = section.querySelector(".js-render-comparison-slider");
		const tabContainer = section.querySelector(".js-render-comparison-tab-container");
		if (!slider || !tabContainer) { return; }

		let isDragging = false;

		const move = (x) => {
			let rect = tabContainer.getBoundingClientRect();
			x = Math.max(0, Math.min(x - rect.left, rect.width));
			let percent = (x / rect.width) * 100;
			tabContainer.style.setProperty('--slider-position-x', `${percent}%`);
		};

		slider.addEventListener("mousedown", () => (isDragging = true));
		window.addEventListener("mouseup", () => (isDragging = false));
		window.addEventListener("mousemove", (e) => {
			if (!isDragging) return;
			move(e.clientX);
		});

		slider.addEventListener("touchstart", () => (isDragging = true));
		window.addEventListener("touchend", () => (isDragging = false));
		window.addEventListener("touchmove", (e) => {
			if (!isDragging) return;
			e.preventDefault();
			move(e.touches[0].clientX);
		}, { passive: false });
	}

	function initRenderComparisonTabs(section) {
		const buttons = section.querySelectorAll(".js-render-comparison-button");
		const tabs = section.querySelectorAll(".js-render-comparison-tab");

		buttons.forEach((button, i) => {
			button.addEventListener("click", (e) => {
				const activeTab = Array.from(tabs).find(tab => tab.classList.contains("is-active"));
				const activeButton = Array.from(buttons).find(button => button.classList.contains("is-active"));
				const selectedTab = Array.from(tabs).find(tab => tab.id === button.dataset.tabId);

				activeTab.classList.remove("is-active");
				activeButton.classList.remove("is-active");

				button.classList.add("is-active");
				selectedTab.classList.add("is-active");
			});
		});
	}

	function initRenderComparisonSections() {
		const $sections = $(".js-render-comparison");
		$sections.each(function () {
			initRenderComparisonSlider(this);
			initRenderComparisonTabs(this);
		});
	}

	function initCustomCursor() {
		$(".slick-arrow").on("mouseenter", function () {
			$(".js-custom-cursor").css("opacity", "1");
		});

		$(".slick-arrow").on("mouseleave", function () {
			$(".js-custom-cursor").css("opacity", "0");
		});
		$doc.mousemove(function (e) {
			var $target = e.target;
			if ($($target).hasClass("slick-next")) {
				$(".js-custom-cursor").css("transform", "rotate(180deg)");
				$(".js-custom-cursor").offset({
					top: e.pageY - 20,
					left: e.pageX - 40,
				});
			}
			if ($($target).hasClass("slick-prev")) {
				$(".js-custom-cursor").css("transform", "rotate(0)");
				$(".js-custom-cursor").offset({
					top: e.pageY - 5,
					left: e.pageX,
				});
			}
		});
	}

	function initVimeo() {
		$(".media__content").each(function (index, el) {
			let $this = $(this);

			if (!$this) return; // Null check

			let $video_el = $this.find(".vimeo-video");

			if ($video_el.length === 0) return; // Null check

			let $parentMedia = $this;
			if (!$parentMedia) return; // Null check

			let element = $video_el[0];

			var viemo_player = new Vimeo.Player(element);
			if (!viemo_player) return; // Null check

			viemo_player.on("play", function () {
				let videoStatus = document.getElementById("videostatus");
				if (videoStatus) videoStatus.innerHTML = "play video!";
			});
			viemo_player.on("pause", function () {
				let videoStatus = document.getElementById("videostatus");
				if (videoStatus) videoStatus.innerHTML = "pause video!";
			});
			viemo_player.on("ended", function () {
				let pauseBtnAlt = $parentMedia.find(".js-pause-alt")[0];
				if (pauseBtnAlt) $(pauseBtnAlt).trigger("click");
			});
			viemo_player.ready().then(function () {
				viemo_player.setVolume(0);
			});

			var playPauseBtn = $parentMedia.find(".js-play-pause")[0];
			var pauseBtn = $parentMedia.find(".js-pause")[0];
			var playPauseBtnAlt = $(el)
				.parents(".media")
				.find(".js-play-pause-alt")[0];
			var pauseBtnAlt = $parentMedia.find(".js-pause-alt")[0];
			var videoWrapper = $(el).parents(".video-alt");

			var muteTogggleBtn = $parentMedia.find(".js-mute-toggle")[0]; // Initialize muteTogggleBtn
			if (muteTogggleBtn) {
				$(muteTogggleBtn).on("click", function (e) {
					e.preventDefault();
					e.stopPropagation();
					$(muteTogggleBtn).toggleClass("active");

					if ($(muteTogggleBtn).hasClass("active")) {
						viemo_player.setVolume(1);
					} else {
						viemo_player.setVolume(0);
					}
				});
			}

			if (playPauseBtn) {
				$(playPauseBtn).on("click", function (e) {
					e.preventDefault();
					e.stopPropagation();
					$(playPauseBtn).addClass("play");
					viemo_player.pause();
				});
			}

			if (pauseBtnAlt) {
				$(pauseBtnAlt).on("click", function (e) {
					e.preventDefault();
					e.stopPropagation();
					if ($(playPauseBtnAlt).hasClass("play")) {
						$(playPauseBtnAlt).removeClass("play");
						$(videoWrapper).removeClass("play");
						viemo_player.pause();
						return;
					} else {
						$(videoWrapper).addClass("play");
						$(playPauseBtnAlt).addClass("play");
						viemo_player.play();
						return;
					}
				});
			}

			$win.on("scroll", function () {
				if ($(el).isInViewport() && !$(el).hasClass("playing")) {
					viemo_player.play();
					$(el).addClass("playing");
					return;
				} else if (!$(el).isInViewport() && $(el).hasClass("playing")) {
					viemo_player.pause();
					$(el).removeClass("playing");
				}
			});
		});

		$(".media").each(function (index, el) {
			let $this = $(this);
			if (!$this) return; // Null check

			let $vimeoVideos = $this.find(".vimeo-video-bg iframe");
			if (!$vimeoVideos || $vimeoVideos.length === 0) return; // Null check

			let vimeoVideos = [];
			$vimeoVideos.each(function () {
				var viemo_player = new Vimeo.Player(el);
				vimeoVideos.push(viemo_player);
			});

			var muteTogggleBtn = $this.find(".js-mute-toggle")[0];
			if (!muteTogggleBtn) return; // Null check

			$(muteTogggleBtn).on("click", function (e) {
				e.preventDefault();
				e.stopPropagation();
				$(muteTogggleBtn).toggleClass("active");

				let volume = $(muteTogggleBtn).hasClass("active") ? 1 : 0;

				if (vimeoVideos.length) {
					vimeoVideos.forEach((video) => {
						if (!video) return; // Null check
						video.setVolume(volume);
					});
				}
			});
		});
	}

	function initAccordion() {
		$(".js-accordion .accordion__section:not(.current) .accordion__body").slideUp();
		$(".js-accordion .accordion__head").on("click tap", function (e) {
			let currentAcc = $(this).parent();
			let accSiblings = currentAcc.siblings(".current");
			let accBody = currentAcc.find(".accordion__body");

			if (currentAcc.hasClass("current")) {
				accBody.slideUp("slow");
				currentAcc.removeClass("current");
				return;
			}

			accBody.slideDown();
			currentAcc.addClass("current");
			accSiblings
				.removeClass("current")
				.find(".accordion__body")
				.slideUp();
		});
	}

	$doc.on(
		"click",
		".js-dot .pin__trigger, .js-dot .dot__trigger",
		function (e) {
			e.preventDefault();
			$(this).parents(".js-dot").toggleClass("open");
		}
	);

	function initCounter() {
		const counterUp = window.counterUp.default;

		const callback = (entries) => {
			entries.forEach((entry) => {
				const el = entry.target;
				if (
					entry.isIntersecting &&
					!el.classList.contains("is-visible")
				) {
					counterUp(el, {
						duration: 1000,
						delay: 5,
					});
					el.classList.add("is-visible");
				}
			});
		};

		const IO = new IntersectionObserver(callback, { threshold: 1 });

		const counter_els = document.querySelectorAll(".counter");
		counter_els.forEach(function (counter_el) {
			IO.observe(counter_el);
		})
	}

	function clickHandlers() {
		$(".js-toggle").on("click", function (e) {
			e.preventDefault();
			$(".menu-wrapper").toggleClass("is-open");
		});

		$(".js-register").on("click", function (e) {
			e.preventDefault();
			var parent = $(this).parents(".section-register");
			var body = $(parent).find(".section__body");
			$(parent).toggleClass("is-open");
			$(body).slideToggle();
		});

		$(".js-open-register").on("click", function (e) {
			e.preventDefault();
			$registerPopup.toggleClass("is-open");
			$(".section-register .section__body").slideToggle();
		});

		$(".js-tabs a").on("click", function (e) {
			e.preventDefault();
			var target = $(this).attr("href");
			$(this)
				.parent()
				.addClass("current")
				.siblings()
				.removeClass("current");
			$(target)
				.addClass("is-current")
				.siblings()
				.removeClass("is-current");
		});

		$(".js-scroll-to-top").on("click", function (e) {
			e.preventDefault();
			$("html, body").animate(
				{
					scrollTop: 0,
				},
				1000,
				"linear"
			);
			fixedHeader();
		});

		$(".js-scroll-to a").on("click", function (e) {
			e.preventDefault();

			var position =
				$($(this).attr("href")).offset().top -
				$header.outerHeight();

			$("body, html").animate(
				{
					scrollTop: position,
				},
				1000,
				"linear"
			);
		});
	}

	function initNavEnquire() {
		$(".js-enquire a").on("click", function (e) {
			e.preventDefault();
			var target = $(this).attr("href");
			$(this)
				.parent()
				.addClass("current")
				.siblings()
				.removeClass("current");
			$(target)
				.addClass("current visible")
				.siblings()
				.removeClass("current");
			var path = window.location.pathname;
			var pathArr = path.split("/");
			var pathLast = pathArr[pathArr.length - 2];
			if (pathLast != "enquire") {
				var url = window.location.href;
				var new_url = url + "enquire/";
				window.history.pushState("data", "Title", new_url);
				document.title = url;
			}
		});

		$(".js-close-enquire").on("click", function (e) {
			e.preventDefault();
			$(this).parents(".current").removeClass("visible current");
			$(".js-enquire").removeClass("current");
		});

		$(window).on("popstate", function (event) {
			var path = window.location.pathname;
			var pathArr = path.split("/");
			var pathLast = pathArr[pathArr.length - 2];
			if (pathLast != "enquire") {
				$("#enquire")
					.removeClass("visible current")
					.siblings()
					.addClass("current");
				$(".js-enquire").removeClass("current");
			}
		});
	}

	function footerSettings() {
		var footerHeight = $(".footer .footer__wrapper").outerHeight();
		$(".site-content").css("paddingBottom", footerHeight - 2.5);
	}

	function footerScroll() {
		var contentBottom =
			$(".wrapper").offset().top + $(".wrapper").outerHeight();
		var footerTop = $(".footer").offset().top;
		var footerBottom = footerTop + $(".footer").outerHeight();

		if (contentBottom < footerBottom && $win.outerWidth() > 768) {
			$registerPopup.addClass("hide");
			$header.addClass("hide");
		} else {
			$registerPopup.removeClass("hide");
			$header.removeClass("hide");
		}

		if (contentBottom < footerTop) {
			$("body").addClass("large-footer");
		}

		if ($win.scrollTop() < footerTop) {
			$("body").removeClass("large-footer");
		}
	}

	function fixedHeader() {
		if ($win.scrollTop() > 20) {
			$header.addClass("fixed");
		} else {
			$header.removeClass("fixed");
		}
	}

	function initSelect() {
		$(".js-select select").selectric();
	}

	var lastScrollTop = 0;
	$win.scroll(function (event) {
		var st = $(this).scrollTop();
		if (st > lastScrollTop && st > 100) {
			$header.addClass("slide-up");
		} else {
			$header.removeClass("slide-up");
		}
		lastScrollTop = st;
	});

	function initMap() {
		if (!$(".js-simple-map").length) {
			return;
		}
		$(".js-simple-map").each(function (index, el) {
			var markers = $(this).data("markers");
			var $map = $(el);
			loadMarkers($map, markers);
		});
	}

	function loadMarkers(map, data) {
		var icon;
		var $mapContainer = $(map);
		var controls = $($mapContainer).data("remove-controls");
		var image = $($mapContainer).data("icon");
		var lat = $($mapContainer).data("lat");
		var lng = $($mapContainer).data("lng");
		var zoom = $($mapContainer).data("zoom");
		var label = $($mapContainer).data("pin-label");
		var mapSettings;

		const myLatLng = { lat: lat, lng: lng };

		if ($win.innerWidth() < 768) {
			var zoom = $($mapContainer).data("zoom-mobile");
			var image = $($mapContainer).data("icon-mobile");
		}

		if (controls == true) {
			mapSettings = {
				center: myLatLng,
				zoom: zoom,
				styles: mapStyles,
				mapTypeControl: false,
				streetViewControl: false,
				fullscreenControl: false,
			};
		} else {
			mapSettings = {
				center: myLatLng,
				zoom: zoom,
				styles: mapStyles,
			};
		}

		var map = new google.maps.Map($(map)[0], mapSettings);

		icon = {
			url: image,
		};

		new google.maps.Marker({
			position: myLatLng,
			icon: icon,
			title: label,
			label: { text: label, className: "pin__label", fontSize: "6px" },
			map,
		});

		$.each(data, function (index, value) {
			var $this = value;
			let markeLatLng = $this.position;
			let markerIcon = $this.icon;
			let markerOpenIcon = $this.icon2;
			let markerIconPlaceholder = $this.icon3;
			let markerTitle = $this.infobox.title;
			let markerAddress1 = $this.infobox.address;
			let markerLink = $this.infobox.url;
			let isOpen = $this.open;
			var clases = "pin js-dot";
			// if (isOpen) {
			//     clases = 'pin js-dot open'
			// }

			var contentString = `
            <div class="${clases}">
            <span class="pin__trigger">
            <img src="${markerOpenIcon}" alt=""/>
            </span>
            <div class="pin__content">
            <a href="${markerLink}"></a>
            <p>${markerTitle}</p>
            </div><!-- /.pin__content -->
            </div><!-- /.pin -->`;

			const marker = new google.maps.Marker({
				position: markeLatLng,
				map,
				icon: markerIconPlaceholder,
			});

			const infowindow = new google.maps.InfoWindow({
				content: contentString,
				icon: markerIconPlaceholder,
			});

			marker.addListener("click", () => {
				infowindow.open(map, marker);
			});

			new google.maps.event.trigger(marker, "click");

			markers.push(marker);
		});
	}

	function initFadeScrollAnimations() {
		gsap.registerPlugin(ScrollTrigger);

		const fadeScrollContainers = document.querySelectorAll(".js-fade-scroll");

		fadeScrollContainers.forEach(function (fadeScrollContainer) {
			const fadeElements = fadeScrollContainer.querySelectorAll(".js-fade-scroll-element");

			if (fadeElements.length > 0) {
				const scrollHeightEnd = (fadeElements.length * 50) + 100;
				fadeScrollContainer.style.height = scrollHeightEnd + "vh";

				const fadeScrollTimeline = gsap.timeline({
					scrollTrigger: {
						trigger: fadeScrollContainer,
						start: "top top",
						end: "bottom bottom",
						scrub: 1,
						invalidateOnRefresh: false,
					}
				});

				fadeElements.forEach(function (fadeElement) {
					fadeScrollTimeline.fromTo(fadeElement, { opacity: 0 }, {
						opacity: 1,
						duration: 1,
						ease: "none",
					});
				});

				fadeScrollTimeline.scrollTrigger.refresh();
			}
		});
	}

	function initParallaxSections() {
		const parallaxElements = document.querySelectorAll('.js-parallax');

		parallaxElements.forEach((parallaxElement, i) => {
			let prevElement = parallaxElement.previousElementSibling;
			while (prevElement) {
				if (prevElement.classList.contains('module-spacer') || prevElement.classList.contains('section-register') || prevElement.classList.contains('section-line-spacer')) {
					prevElement = prevElement.previousElementSibling;
					continue;
				}

				let topOffset = 0;
				if (prevElement.offsetHeight > window.innerHeight) {
					topOffset = window.innerHeight - prevElement.offsetHeight;
				}

				prevElement.classList.add('is-parallax');
				prevElement.style.setProperty('--offeset-top', `${topOffset}px`);
				break;
			}
		});
	}

	function highlightSoldSlots() {
		const $floorplans = $(".js-floorplan");

		$floorplans.each(function () {
			const $floorplan = $(this);
			const $svg = $floorplan.find("svg");
			const soldSlotsString = $floorplan.data("slots");
			const soldSlotsArray = soldSlotsString.split(", ");
			soldSlotsArray.forEach(function (soldSlot) {
				$svg.find(`[data-id="${soldSlot}"]`).addClass("closed");
			});
		});
	}

	function isTouchDevice() {
		return (
			"ontouchstart" in window ||
			navigator.maxTouchPoints > 0 ||
			navigator.msMaxTouchPoints > 0
		);
	}


	function updateCssProperties() {
		const documentStyles = document.documentElement.style;

		if ($header.length) {
			let headerHeight = $header.innerHeight();
			documentStyles.setProperty("--header-height", headerHeight + "px");
		}

		if ($registerPopup.length) {
			let registerPopupHeight = $registerPopup.innerHeight();
			documentStyles.setProperty("--register-popup-height", registerPopupHeight + "px");
		}
	}

	function toggleFooterVisibility() {
		if ($(window).scrollTop() > 100) {
			$(".footer").addClass("visible");
		} else {
			$(".footer").removeClass("visible");
		}
	}

	$doc.on("mouseover", ".js-floor", function () {
		if (isTouchDevice()) {
			return;
		}
		var target = $(this).data("target");
		$(this).addClass("active");
		$(`[data-target="${target}"]`).addClass("active");
	});

	$doc.on("mouseleave", ".js-floor", function () {
		if (isTouchDevice()) {
			return;
		}
		var target = $(this).data("target");
		if (!$(target).hasClass("current")) {
			$(this).removeClass("active");
			$(`[data-target="${target}"]`).removeClass("active");
		}
	});

	$doc.on("click tab", function (e) {
		var $target = e.target;
		if (
			!$($target).hasClass("js-floor") &&
			!$($target).parents(".js-floor").length > 0
		) {
			$(".section-floorplan-popup.show").removeClass("show");
			$(".js-floor").removeClass("active");
			$(".floor-link").removeClass("active");
		}
	});

	$doc.on("click tab", ".js-floor", function (e) {
		e.preventDefault();
		$(".js-floor").removeClass("active");
		$(".floor-link").removeClass("active");
		var target = $(this).data("target");
		$(this).addClass("active");
		$(target).addClass("current").siblings().removeClass("current");
		$(".section-floorplan-popup").addClass("show");
		$(`[data-target="${target}"]`).addClass("active");
	});


	$win.on("load", function () {
		initVideo();
		onYouTubeIframeAPIReady();
		onYouTubeIframeAPIReadyBtn();
		initSlider();
		initSliderAlt();
		initTextImageSliders();
		initRenderComparisonSections();
		initVimeo();
		initAccordion();
		initCounter();
		clickHandlers();
		initSelect();
		initNavEnquire();
		initFadeScrollAnimations();
		initParallaxSections();
		highlightSoldSlots();
		setTimeout(function () {
			$("body").addClass("page-loaded");
		}, 1000);
		initMap();
		initCustomCursor();
		fixedHeader();
		toggleFooterVisibility();
		footerSettings();
		updateCssProperties();
	}).on("resize", function () {
		fixedHeader();
		toggleFooterVisibility();
		footerScroll();
		footerSettings();
		initParallaxSections();
		updateCssProperties();
	}).on("scroll", function () {
		fixedHeader();
		toggleFooterVisibility();
		footerScroll();
	});

	$(".footer .form .gform_button").on("click", function (e) { });

	$doc.bind("gform_post_render", function () {
		footerSettings();
	});

	$doc.bind("gform_confirmation_loaded", function (event, formId) {
	});
})(jQuery, window, document);
